/**
 * 全局错误码处理工具
 * 用于统一处理后端返回的错误码，并转换为多语言错误消息
 */

import { I18N_KEYS } from '@/i18n/keys';

/**
 * 错误码到 i18n key 的映射表
 * 根据 ErrorMessageEnum 中定义的错误码进行映射
 */
const ERROR_CODE_MAP = {
  // 认证相关错误 (E2xx)
  'E200': I18N_KEYS.AUTH.ERROR_E200,  // token校验失败
  'E201': I18N_KEYS.AUTH.ERROR_E201,  // 数据上传失败
  'E202': I18N_KEYS.AUTH.ERROR_E202,  // 设计请求发送失败
  'E203': I18N_KEYS.AUTH.ERROR_E203,  // 管理员token校验失败
  'E204': I18N_KEYS.AUTH.ERROR_E204,  // 密码修改失败
  'E215': I18N_KEYS.AUTH.ERROR_E215,  // 当前角色无权访问该接口
  'E205': I18N_KEYS.AUTH.ERROR_E205,  // 验证码有误
  'E206': I18N_KEYS.AUTH.ERROR_E206,  // 用户不存在
  'E207': I18N_KEYS.AUTH.ERROR_E207,  // 旧密码输入不正确
  'E208': I18N_KEYS.AUTH.ERROR_E208,  // 用户、手机号或密码验证失败
  'E209': I18N_KEYS.AUTH.ERROR_E209,  // 用户名已存在
  'E2010': I18N_KEYS.AUTH.ERROR_E2010, // 手机号已存在
  'E2011': I18N_KEYS.AUTH.ERROR_E2011, // 获取验证码失败
  'E2012': I18N_KEYS.AUTH.ERROR_E2012, // 邮箱已存在
  'E2013': I18N_KEYS.AUTH.ERROR_E2013, // 验证码发送过于频繁
  'E210': I18N_KEYS.AUTH.ERROR_E210,  // 设计请求超时
  'E211': I18N_KEYS.AUTH.ERROR_E211,  // 数据下载失败
  'E400': I18N_KEYS.AUTH.ERROR_E400,  // 数据库记录输入数据错误
  'E410': I18N_KEYS.AUTH.ERROR_E410,  // 数据库记录输出数据错误
  'E411': I18N_KEYS.AUTH.ERROR_E411,  // 数据库超时
  // 订单相关错误 (E3xx)
  'E300': I18N_KEYS.AUTH.ERROR_E300,  // 创建订单失败
  'E301': I18N_KEYS.AUTH.ERROR_E301,  // 订单状态获取失败
  'E302': I18N_KEYS.AUTH.ERROR_E302,  // 订单列表查询失败
  'E303': I18N_KEYS.AUTH.ERROR_E303,  // 支付详情获取失败
  'E304': I18N_KEYS.AUTH.ERROR_E304,  // 用户不存在，创建订单失败
  'E305': I18N_KEYS.AUTH.ERROR_E305,  // 钱包已被封禁，无法创建订单
  'E306': I18N_KEYS.AUTH.ERROR_E306,  // 钱包余额不足，请充值
  'E307': I18N_KEYS.AUTH.ERROR_E307,  // 支付执行失败，已支付的订单不能再次选择
  'E308': I18N_KEYS.AUTH.ERROR_E308,  // 继续支付请求失败
  'E309': I18N_KEYS.AUTH.ERROR_E309,  // 删除失败，只能在支付发起2小时后删除
  'E310': I18N_KEYS.AUTH.ERROR_E310,  // 订阅计划ID不能为空
  'E311': I18N_KEYS.AUTH.ERROR_E311,  // 不支持的订阅计划
  'E312': I18N_KEYS.AUTH.ERROR_E312,  // 幂等键不能为空
  'E313': I18N_KEYS.AUTH.ERROR_E313,  // 请勿提交重复订单
  'E314': I18N_KEYS.AUTH.ERROR_E314,  // 用户在免费试用期间，无法取消订阅
  'E315': I18N_KEYS.AUTH.ERROR_E315,  // 只有订阅用户才能充值永久点数
  'E316': I18N_KEYS.AUTH.ERROR_E316,  // 系统正在处理订单，请在02:00之后再取消订阅
  'E317': I18N_KEYS.AUTH.ERROR_E317,  // 上一笔设计任务仍在进行中
  'E318': I18N_KEYS.AUTH.ERROR_E318,  // AI设计次数已达上限
  'E319': I18N_KEYS.AUTH.ERROR_E319,  // 未找到该幂等键对应的订单
  'E320': I18N_KEYS.AUTH.ERROR_E320,  // 订单未支付成功，无法生成发票
  'E321': I18N_KEYS.AUTH.ERROR_E321,  // 无权访问该订单
  'E322': I18N_KEYS.AUTH.ERROR_E322,  // PDF生成失败
  // 钱包相关错误 (E4xx)
  'E401': I18N_KEYS.AUTH.ERROR_E401,  // 获取钱包数据失败
  // 订阅相关错误 (E5xx)
  'E500': I18N_KEYS.AUTH.ERROR_E500,  // 获取订阅信息失败
  'E501': I18N_KEYS.AUTH.ERROR_E501,  // 创建订阅失败
  'E502': I18N_KEYS.AUTH.ERROR_E502,  // 获取订阅计划失败
  // 交易记录相关错误 (E6xx)
  'E600': I18N_KEYS.AUTH.ERROR_E600,  // 查询金币流水记录失败
  // AI设计相关错误 (E7xx)
  'E700': I18N_KEYS.AUTH.ERROR_E700,  // 创建AI设计失败
  'E701': I18N_KEYS.AUTH.ERROR_E701,  // 创建AI设计异常
  // 图片收藏相关错误 (E8xx)
  'E800': I18N_KEYS.AUTH.ERROR_E800,  // 获取图片收藏状态失败
  'E801': I18N_KEYS.AUTH.ERROR_E801,  // 设置图片收藏失败
  'E802': I18N_KEYS.AUTH.ERROR_E802,  // 取消图片收藏失败
  'E803': I18N_KEYS.AUTH.ERROR_E803,  // 用户未登录或用户信息获取失败
  'E804': I18N_KEYS.AUTH.ERROR_E804,  // 图片URL不能为空
  'E805': I18N_KEYS.AUTH.ERROR_E805,  // 项目ID不能为空
  'E806': I18N_KEYS.AUTH.ERROR_E806,  // 图片记录不存在，无法设置收藏
  'E807': I18N_KEYS.AUTH.ERROR_E807,  // 收藏图片数量已达上限
  'E808': I18N_KEYS.AUTH.ERROR_E808,  // 无法定位对应项目结果
  // 管理员账号发行相关错误 (E10xx)
  'E1000': I18N_KEYS.AUTH.ERROR_E1000, // 单个账号创建失败
  'E1001': I18N_KEYS.AUTH.ERROR_E1001, // 批量账号发行失败
  'E1002': I18N_KEYS.AUTH.ERROR_E1002, // 无修改权限
  // 活动代码相关错误 (E9xx)
  'E900': I18N_KEYS.AUTH.ERROR_E900,  // 活动代码无效
  'E901': I18N_KEYS.AUTH.ERROR_E901,  // 活动代码已过期
  'E902': I18N_KEYS.AUTH.ERROR_E902,  // 活动代码不适用于自动续费
  'E903': I18N_KEYS.AUTH.ERROR_E903,  // 活动代码仅适用于月度订阅
  'E904': I18N_KEYS.AUTH.ERROR_E904,  // 活动代码使用次数已用完
  'E905': I18N_KEYS.AUTH.ERROR_E905,  // 当前支付方式不支持使用活动代码
  // 案件相关错误 (E11xx)
  'E1100': I18N_KEYS.CASE.ERROR_E1100,
  'E1101': I18N_KEYS.CASE.ERROR_E1101,
  'E1102': I18N_KEYS.CASE.ERROR_E1102,
  'E1103': I18N_KEYS.CASE.ERROR_E1103,
  'E1104': I18N_KEYS.CASE.ERROR_E1104,
  'E1105': I18N_KEYS.CASE.ERROR_E1105,
  'E1106': I18N_KEYS.CASE.ERROR_E1106,
  'E1107': I18N_KEYS.CASE.ERROR_E1107,
  'E1108': I18N_KEYS.CASE.ERROR_E1108,
  'E1109': I18N_KEYS.CASE.ERROR_E1109,
  'E1110': I18N_KEYS.CASE.ERROR_E1110,
  'E1111': I18N_KEYS.CASE.ERROR_E1111,
  'E1112': I18N_KEYS.CASE.ERROR_E1112,
  // 素材ライブラリ（管理 → ライブラリ）
  'DESIGN_ASSET_CODE_EXISTS': I18N_KEYS.CASE.ERROR_DESIGN_ASSET_CODE_EXISTS,
};

/**
 * 从错误响应中提取错误码
 * 只支持 ResponseBean.errorCode 字段格式
 *
 * @param {object} errorResponse - ResponseBean 响应对象，包含 errorCode 字段
 * @returns {string|null} - 错误码，如 "E205"，如果不存在则返回 null
 */
export function extractErrorCode(errorResponse) {
  if (!errorResponse || typeof errorResponse !== 'object') {
    return null;
  }

  // 直接从 errorCode 字段获取
  return errorResponse.errorCode || null;
}

/**
 * 根据错误码获取对应的 i18n key
 * @param {string} errorCode - 错误码，如 "E205"
 * @returns {string|null} - i18n key，如果找不到则返回 null
 */
export function getErrorI18nKey(errorCode) {
  if (!errorCode) return null;
  return ERROR_CODE_MAP[errorCode] || null;
}

/**
 * 解析后端错误并返回多语言错误消息
 * 使用 ResponseBean.errorCode 字段进行翻译
 *
 * @param {object} errorResponse - ResponseBean 响应对象，包含 errorCode 字段
 * @param {function} i18nFn - i18n 翻译函数，如 this.$st 或 i18n.t
 * @returns {string} - 多语言错误消息，如果无法解析则返回原始消息
 */
export function getLocalizedErrorMessage(errorResponse, i18nFn) {
  if (!errorResponse || typeof errorResponse !== 'object') {
    return null;
  }

  // 提取错误码
  const errorCode = extractErrorCode(errorResponse);
  if (!errorCode) {
    // 如果没有 errorCode，返回原始消息（作为 fallback）
    return errorResponse.msg || String(errorResponse);
  }

  // 获取 i18n key
  const i18nKey = getErrorI18nKey(errorCode);
  if (!i18nKey || !i18nFn) {
    // 如果找不到 i18n key 或没有提供翻译函数，返回原始消息
    return errorResponse.msg || String(errorResponse);
  }

  // 返回翻译后的消息
  try {
    const translated = i18nFn(i18nKey);
    return translated;
  } catch (e) {
    console.warn('Failed to translate error message:', e);
    return errorResponse.msg || String(errorResponse);
  }
}

/**
 * 处理 ResponseBean 响应，提取错误码和多语言消息
 *
 * @param {object} response - ResponseBean 响应对象
 * @param {function} i18nFn - i18n 翻译函数
 * @returns {object} - 处理后的响应对象，包含 errorCode 和 localizedMsg 字段
 */
export function processErrorResponse(response, i18nFn) {
  if (!response) return response;

  // 如果响应成功，直接返回
  if (response.status === 200) {
    return response;
  }

  // 提取错误码（只从 errorCode 字段获取）
  const errorCode = extractErrorCode(response);
  const localizedMsg = getLocalizedErrorMessage(response, i18nFn);

  return {
    ...response,
    errorCode,
    localizedMsg,
  };
}
